import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, EntityView, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { Cadenas } from "../../Cadenas/Cadenas";
import { catCanales } from "../../Categorias y Estados/catCanales";
import { Personal } from "../../Personal/Personal";
import { Tiendas } from "../../Tiendas/Tiendas";
import { RutasTiendasFilters } from "../RutasTiendasFilters/RutasTiendasFilters";
import { CoberturaTiendasViewColumnsOverrides } from "./CoberturaTiendasViewColumnsOverrides";
import { CoberturaTiendasViewInfoWindowRenderer } from "./CoberturaTiendasViewInfoWindowRenderer";
import { CoberturaTiendasViewMarkerRenderer } from "./CoberturaTiendasViewMarkerRenderer";

const columns = () =>
(
    {
        c_tienda_id: new EntityColumn<string>({ name: 'c_tienda_id', type: 'char', length: 20, flags: c.PK, prompt: 'Tienda Id' }),
        c_cadena_id: new EntityColumn<string>({ name: 'c_cadena_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Cadena' }),
        vc_canales: new EntityColumn<string[]>({ name: 'vc_canales', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Canales', isArray: true }),
        vc_domicilio_completo: new EntityColumn<string>({ name: 'vc_domicilio_completo', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Domicilio Completo' }),
        i_cantidad_clientes: new EntityColumn<number>({ name: 'i_cantidad_clientes', type: 'int', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Cantidad Clientes' }),
        i_cantidad_productos: new EntityColumn<number>({ name: 'i_cantidad_productos', type: 'int', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Cantidad Productos' }),
        f_latitud: new EntityColumn<number>({ name: 'f_latitud', type: 'float', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Latitud' }),
        f_longitud: new EntityColumn<number>({ name: 'f_longitud', type: 'float', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Longitud' }),
        vc_cobertura_compartida: new EntityColumn<string>({ name: 'vc_cobertura_compartida', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Cobertura Compartida' }),
        vc_cobertura_exclusiva: new EntityColumn<string>({ name: 'vc_cobertura_exclusiva', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Cobertura Exclusiva' }),
        vc_personal: new EntityColumn<string[]>({ name: 'vc_personal', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Supervisión', isArray: true }),
        n_horas_compartidas_configuradas: new EntityColumn<number>({ name: 'n_horas_compartidas_configuradas', type: 'decimal', scale: 2, flags: c.Edit, prompt: 'Horas Compartidas Configuradas' }),
        n_horas_exclusivas_configuradas: new EntityColumn<number>({ name: 'n_horas_exclusivas_configuradas', type: 'decimal', scale: 2, flags: c.Edit, prompt: 'Horas Exclusivas Configuradas' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        rtcf_brwStandard: { name: 'rtcf_brwStandard', keyMappings: { c_tienda_id: 0 } } as EntityView,
        rtcf_brwCoberturaTiendas: {
            name: 'rtcf_brwCoberturaTiendas', keyMappings: { c_tienda_id: 0 },
            FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new RutasTiendasFilters(client, parentKeys),
            gridColumnsOverrides: CoberturaTiendasViewColumnsOverrides,
            mapMarkerRenderer: CoberturaTiendasViewMarkerRenderer,
            mapInfoWindowRenderer: CoberturaTiendasViewInfoWindowRenderer
        },
    }
)

const lookups = () =>
(
    {
        'Personal': {
            name: 'Personal',
            view: 'perl_brwJefes',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Personal(client, parentKeys)
        },
        'Tiendas': {
            name: 'Tiendas',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Tiendas(client, parentKeys)
        },
        'Canales': {
            name: 'Canales',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catCanales(client, parentKeys)
        },
        'Cadenas': {
            name: 'Cadenas',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new Cadenas(client, parentKeys)
        }
    }
)

export class RutasTiendasConfiguracionDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();

    constructor() {
        super('RutasTiendasConfiguracion');
    }
}